import { useRouter } from 'next/router'
import { getRoute } from 'utils/helpers'
import Meta from 'components/meta/meta'
import Search from 'components/input/search/search'
import Splitted from 'components/splitted/splitted'
import styles from './account.module.scss'
import { get } from 'utils/api'
import useAppState from 'utils/state'

export default function Account({ children, title }) {
    const router = useRouter()
    const { pathname } = router
    const { user, loading } = useAppState()
    const contractUrl = getRoute('account-contract')
    const settingsUrl = getRoute('account-settings')

    if (loading) return null

    if (!user || !user.account_id) {
        router.push('/')
        return null
    }

    if (!user.account_verified && pathname != contractUrl && pathname != settingsUrl) {
        router.push(contractUrl)
        return null
    }

    const items = !user.account_verified
        ? null
        : [
              {
                  text: 'Apžvalga',
                  url: getRoute('account-dashboard'),
                  icon: 'home'
              },
              // {
              //     text: 'Pasiūlymai',
              //     url: getRoute('account-deals'),
              //     icon: 'tag',
              //     tag: 'Naujiena'
              // },
              {
                  text: 'Prekės',
                  url: getRoute('account-products'),
                  icon: 'database'
              },
              {
                  text: 'Užsakymai',
                  url: getRoute('account-purchases'),
                  icon: 'money',
                  count: user.pending_shipments,
                  tooltip: 'Laukiama išsiuntimo'
              },
              {
                  text: 'Naujienos',
                  count: user.unseen_updates,
                  url: getRoute('account-updates'),
                  icon: 'file-text'
              },
              {
                  text: 'Nustatymai',
                  url: settingsUrl,
                  icon: 'settings'
              },
              {
                  text: 'Sąskaitos',
                  url: getRoute('account-invoices'),
                  icon: 'file-text'
              },
              {
                  text: 'Patarimai',
                  url: getRoute('blog'),
                  icon: 'book'
              },
              {
                  text: 'Peržiūrėti',
                  url: getRoute('shop', { slug: user.account_slug }),
                  icon: 'eye'
              }
          ]

    const handleAccountChange = async ({ value }) => {
        await get(`switch-account/${value}`)
        window.location.href = getRoute('account-dashboard')
    }

    let input
    if (user.is_admin) {
        const accounts = Object.entries(user.accounts).map(data => ({
            value: parseInt(data[0]),
            name: data[1]
        }))

        input = (
            <Search
                simple
                white
                options={accounts}
                value={user.account_id}
                className={styles.input}
                onChange={handleAccountChange}
            />
        )
    }

    return (
        <Splitted title={title} items={items} input={input}>
            <Meta title={title} />
            {children}
        </Splitted>
    )
}
